import { Breadcrumbs, css, styled } from '@mui/material';
import { Link } from 'react-router-dom';
import palette from 'theme/palette';

export const RootStyled = styled('div')`
  ${({ theme }) => css`
    display: flex;
    flex-direction: column;
    background-color: ${theme.palette.background.primary};
    border-bottom: 1px solid ${theme.palette.grey[900]};
    min-height: 72px;
    padding: ${theme.spacing(1, 4)};
  `}
`;

export const BreadcrumbsStyled = styled(Breadcrumbs)`
  ${({ theme }) => css`
    & > ol {
      align-items: baseline;
    }
    & .MuiBreadcrumbs-separator {
      margin: ${theme.spacing(0.5, 0.5, 0)};
      font-size: ${theme.typography.caption.fontSize};
    }
  `}
`;

export const LinkStyled = styled(Link)<{ isLastItem: boolean }>`
  ${({ isLastItem }) => css`
    color: ${palette.primary.link};
    text-decoration: none;

    &:hover {
      text-decoration: underline;
    }

    ${isLastItem &&
    css`
      &:visited {
        color: ${palette.primary.link};
      }
    `}
  `}
`;

export const DivLinkStyled = styled('div')`
  ${({ theme }) => css`
    color: ${palette.primary.link};
    cursor: pointer;

    &:hover {
      text-decoration: underline;
      color: ${palette.secondary.link};
    }
  `}
`;
